export const INITIAL_STATE = {
  folders: [],
  q: '',
  view: 'list'
}

const reducer = (state = INITIAL_STATE, action) => {

  switch (action.type) {

  case 'CHANGE_FOLDER':
    return {
      ...state,
      folders: [
        ...state.folders,
        action.folder
      ],
      q: ''
    }

  case 'UP':
    return {
      ...state,
      folders: state.folders.slice(0, -1)
    }

  case 'SET_QUERY':
    return {
      ...state,
      q: action.q,
      folders: []
    }

  case 'TOGGLE_VIEW':
    return {
      ...state,
      view: state.view === 'list' ? 'grid' : 'list'
    }

  default:
    return state

  }

}

export default reducer
